/* @ngInject */
const displayCtrl = (
  $scope,
  $$setting,
  $$railway,
  authService,
  entities,
  utils,
  displayMenu,
  toaster
) => {
  $scope.railwayFields = $$railway.metadata.fields
  $scope.utils = utils
  $scope.entities = entities
  $scope.displayMenu = displayMenu

  $scope.saveSetting = async (_fields, _name) => {
    const dataString = $$setting.format.fieldsToString(_fields)

    const data = {
      userId: authService.getUid(),
      dataString,
      name: _name,
    }

    try {
      const message = await $$setting.requests.save(data)
      toaster.message(message)
    } catch (error) {
      toaster.error(error)
    }
  }
}

export default displayCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/display/display.controller.js